import { Column, ModelBase } from 'loca-boot-core'

/**
 * 加电资源
 */
export interface PowerResource {
  /**
   * 加电资源id
   */
  id: string

  /**
   * 加电资源名称
   */
  name: string

  /**
   * 加电资源是否可点击
   */
  clickAvailable: boolean

  /**
   * 资源点类型 20231221新增
   * RECHARGE :recharge 充换电资源 NIO_STORE :nio_store 蔚来门店资源 TEST_DRIVE :test_drive 试驾点资源
   */
  pointType: string

  /**
   * 资源点子类型 20231221新增
   * POWER_SWAP :PowerSwap 换电站资源 CHARGE_STATION :ChargeStation 充电站资源 NIO_SPACE :NioSpace 蔚来空间 NIO_HOUSE :NioHouse 蔚来中心 TEST_DRIVE :TestDrive 试驾点
   */
  pointSubType: string

  /**
   * 加电资源类别：ChargeStation / PowerSwap / Merged，其中 Merged 表示字段是 merge 的结果
   */
  type: string

  /**
   * 桩群类型。仅type为ChargeStation时有该字段
   * NioChargeStationNpc: nio超充桩
   * NioChargeStationDest: nio目的地充电桩
   * ThirdChargeStation: 三方桩
   */
  chargeStationType: string

  /**
   * 聚合点资源类型：ChargeStation / PowerSwap / Mix
   */
  mergeType: string

  /**
   * 加电资源位置。type 为 Merged 的 时候为 Merged 中心点位置
   */
  location: string

  /**
   * 运营商id
   */
  operatorId: string

  /**
   * 运营商名称
   */
  operatorName: string

  /**
   * 建设场所：
   * 1: 居民区
   * 2: 公共机构
   * 3: 企事业单位
   * 4: 写字楼
   * 5: 工业园区
   * 6: 交通枢纽
   * 7: 大型文体设施
   * 8: 城市绿地
   * 9: 大型建筑配建停车场
   * 10: 路边停车位
   * 11: 城际高速服务区
   * 201: 酒店民宿
   * 202: 景区乐园
   * 203: 商业中心
   * 255: 其他
   */
  construction: string

  /**
   * 地址
   */
  address: string

  /**
   * 资源merge之后的总数
   */
  resourceNumber: number

  /**
   * 权益概述
   */
  rightDescSummary: number

  /**
   * 权益详细描述
   */
  rightDescDetailArray: string[]

  /**
   * 资源点在路线中的位置索引
   */
  index: number[]

  /**
   * lng坐标
   */
  lng?: number

  /**
   * lat坐标
   */
  lat?: number

  /**
   * 换电站正在换电状态
   * 0表示空闲状态，1表示换电状态
   */
  swapStatus?: number

  /**
   * 20240718 - 资源详情新增【升级改造中】提示条
   */
  swapSupportingImageUrl?: string
}

/**
 * 地图标注类型
 */
export enum MarkerType {
  /**
   * 图标类标注
   */
  Icon = 'Icon',
  /**
   * 文本类标注
   */
  Text = 'Text',
  /**
   * 聚合类标注
   */
  Merged = 'Merged',
  /**
   * 混合类标注
   */
  Mixed = 'Mixed',
  /**
   * 标题类标注
   */
  Title = 'Title',
  /**
   * 标题类标注
   */
  Animation = 'Animation',
}

// /**
//  * 地图标注
//  */
// export interface IMarker extends Marker {
//   /**
//    * 地图标注id
//    */
//   id: string
//   /**
//    * 地图标注类型
//    */
//   type: MarkerType
//   /**
//    * 地图标注位置
//    */
//   loc: Point
//   /**
//    * 地图标注icon
//    */
//   icon: string
//   /**
//    * 地图标注标题
//    */
//   title?: string
//   /**
//    * 地图标注标签
//    */
//   label?: string
//   /**
//    * 地图标注是否可点击
//    */
//   clickable?: boolean
//   /**
//    * marker是否可根据zoom缩放
//    */
//   zoomable?: boolean
//   /**
//    * 地图标注尺寸
//    */
//   size?: Size
//   /**
//    * 地图标注的层级
//    */
//   zIndex?: number
//   /**
//    * 地图标注携带的数据
//    */
//   data?: unknown
//   /**
//    * 换电站正在换电状态
//    * 0表示空闲状态，1表示换电状态
//    */
//   swapStatus?: number
//   /**
//    * 自定义参数
//    */
//   customData?: any
// }

/**
 * 加电资源
 */
export class ResourceItemModel extends ModelBase implements PowerResource {
  /**
   * 加电资源id
   */
  @Column()
  public id!: string

  /**
   * 加电资源名称
   */
  @Column()
  public name!: string

  /**
   * 加电资源是否可点击
   */
  @Column()
  public clickAvailable!: boolean

  /**
   * 资源点类型 20231221新增
   * RECHARGE :recharge 充换电资源 NIO_STORE :nio_store 蔚来门店资源 TEST_DRIVE :test_drive 试驾点资源
   */
  @Column()
  public pointType!: string

  /**
   * 资源点子类型 20231221新增
   * POWER_SWAP :PowerSwap 换电站资源 CHARGE_STATION :ChargeStation 充电站资源 NIO_SPACE :NioSpace 蔚来空间 NIO_HOUSE :NioHouse 蔚来中心 TEST_DRIVE :TestDrive 试驾点
   */
  @Column()
  public pointSubType!: string

  /**
   * 加电资源类别：ChargeStation / PowerSwap / Merged，其中 Merged 表示字段是 merge 的结果
   */
  @Column()
  public type!: string

  /**
   * 桩群类型。仅type为ChargeStation时有该字段
   * NioChargeStationNpc: nio超充桩
   * NioChargeStationDest: nio目的地充电桩
   * ThirdChargeStation: 三方桩
   */
  @Column()
  public chargeStationType!: string

  /**
   * 聚合点资源类型：ChargeStation / PowerSwap / Mix
   */
  @Column()
  public mergeType!: string

  /**
   * 加电资源位置。type 为 Merged 的 时候为 Merged 中心点位置
   */
  @Column()
  public location!: string

  /**
   * 运营商id
   */
  @Column()
  public operatorId!: string

  /**
   * 运营商名称
   */
  @Column()
  public operatorName!: string

  /**
   * 建设场所：
   * 1: 居民区
   * 2: 公共机构
   * 3: 企事业单位
   * 4: 写字楼
   * 5: 工业园区
   * 6: 交通枢纽
   * 7: 大型文体设施
   * 8: 城市绿地
   * 9: 大型建筑配建停车场
   * 10: 路边停车位
   * 11: 城际高速服务区
   * 201: 酒店民宿
   * 202: 景区乐园
   * 203: 商业中心
   * 255: 其他
   */
  @Column()
  public construction!: string

  /**
   * 地址
   */
  @Column()
  public address!: string

  /**
   * 资源merge之后的总数
   */
  @Column()
  public resourceNumber!: number

  /**
   * 权益概述
   */
  @Column()
  public rightDescSummary!: number

  /**
   * 权益详细描述
   */
  @Column()
  public rightDescDetailArray!: string[]

  /**
   * 资源点在路线中的位置索引
   */
  @Column()
  public index!: number[]

  /**
   * 换电站类型
   */
  @Column()
  public model!: string

  /**
   * 图片
   */
  @Column()
  public image!: string

  /**
   * 换电站正在换电状态
   * 0表示空闲状态，1表示换电状态
   */
  @Column()
  public swapStatus!: number

  /**
   * 白名单
   */
  @Column({ default: false })
  public hideDetail!: boolean

  @Column()
  public distance!: number

  /**
   * 20240718 - 资源详情新增【升级改造中】提示条
   */
  @Column()
  public swapSupportingImageUrl?: string

  @Column()
  public swapSupportStatus?: number
}

/**
 * 加电资源列表
 */
export class ResourceListModel extends ModelBase {
  /**
   * 三方桩是否聚合
   */
  @Column({ name: 'third_charge_station_summary_available' })
  public thirdSummaryAvailable!: boolean

  /**
   * 加电资源列表   20231221 name: 'powers 改为 name: 'resources'
   */
  @Column({ name: 'resources', childType: ResourceItemModel, autowired: true })
  public powers?: ResourceItemModel[]

  /**
   * 组件配置列表
   */
  @Column({ name: 'components', childType: ResourceItemModel, autowired: true })
  public components?: ResourceItemModel[]
}
